import classNames from 'classnames';
import { QuoteExpiredSummary } from 'routes/essential-workspace/components/quote-panel/quote/summary/expired';
import { QuoteNotReadySummary } from 'routes/essential-workspace/components/quote-panel/quote/summary/not-ready';
import { QuotePricedSummary } from 'routes/essential-workspace/components/quote-panel/quote/summary/priced';
import { QuotePricingSummary } from 'routes/essential-workspace/components/quote-panel/quote/summary/pricing';
import { QuoteReadySummary } from 'routes/essential-workspace/components/quote-panel/quote/summary/ready';
import { QuoteRejectedSummary } from 'routes/essential-workspace/components/quote-panel/quote/summary/rejected';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';

export function QuoteSummary({ className }: { className?: string }) {
  const { status, textColor, formId } = useQuote();

  switch (status) {
    case 'not-ready':
      return <QuoteNotReadySummary className={classNames(textColor, className)} formId={formId} />;
    case 'ready':
      return <QuoteReadySummary className={classNames(textColor, className)} formId={formId} />;
    case 'price-in-progress':
      return <QuotePricingSummary className={classNames(textColor, className)} formId={formId} />;
    case 'priced':
      return <QuotePricedSummary className={classNames(textColor, className)} formId={formId} />;
    case 'price-expired':
      return <QuoteExpiredSummary className={classNames(textColor, className)} formId={formId} />;
    case 'price-rejected':
      return <QuoteRejectedSummary className={classNames(textColor, className)} formId={formId} />;
    default:
      return null;
  }
}
